import { render, staticRenderFns } from "./AddCircleIcon.vue?vue&type=template&id=98bc496c&"
import script from "./AddCircleIcon.vue?vue&type=script&lang=ts&"
export * from "./AddCircleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports